import styled from "styled-components";

export const GeralWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

 
`;

export const BubbleContainer = styled.div`
  background-color: ${(props) => props.theme.topElementsColor};
  padding: 20px;
  margin-top: 10px;
  margin-left: 10px;
  border-radius: 15px;
  height: fit-content;
  width: 100%;
  text-align: center;
  h1 {
    font-weight: 300;
    font-family: "Rubik"
  }


`;

export const setyledText = styled.div`
 padding-top: 20px;
  width: 100%¨;
  display: flex;
  justify-content:center;
  p{
    text-align: center;
    }
`
